export const initPresentation = () => ({
  type: "INIT_PRESENTATION"
});

export const fetchPresentation = presentation => ({
  type: "FETCH_PRESENTATION",
  payload: presentation
});

export const setPresentationDate = date => ({
  type: "SET_PRESENTATION_DATE",
  date
});

export const setPresentationTarget = target => ({
  type: "SET_PRESENTATION_TARGET",
  target
});

export const setPresentationIsPrepared = isPrepared => ({
  type: "SET_PRESENTATION_IS_PREPARED",
  isPrepared
});

export const setPresentationIsPresented = isPresented => ({
  type: "SET_PRESENTATION_IS_PRESENTED",
  isPresented
});

export const setPresentationThankingSlide = thankingSlide => ({
  type: "SET_PRESENTATION_THANKING_SLIDE",
  thankingSlide
});

export const setPresentationQuestionsSlide = questionsSlide => ({
  type: "SET_PRESENTATION_QUESTIONS_SLIDE",
  questionsSlide
});

export const setPresentationExtraSlides = extraSlides => ({
  type: "SET_PRESENTATION_EXTRA_SLIDES",
  extraSlides
});

export const setShowFrameExtraSlides = showFrame => ({
  type: "SET_SHOW_FRAME_EXTRA_SLIDES",
  showFrame
});

export const setPresentationExtraSlidesContent = content => ({
  type: "SET_PRESENTATION_EXTRA_SLIDES_CONTENT",
  content
});

// @todo Delete Conclusion
export const setPresentationConclusion = conclusion => ({
  type: "SET_PRESENTATION_CONCLUSION",
  conclusion
});

export const setPresentationConclusionContent = content => ({
  type: "SET_PRESENTATION_CONCLUSION_CONTENT",
  content
});

export const setPresentationHiddenSlides = hiddenSlides => ({
  type: "SET_PRESENTATION_HIDDEN_SLIDES",
  hiddenSlides
});

export const setPresentationCurrentSlideIndex = currentSlideIndex => ({
  type: "SET_PRESENTATION_CURRENT_SLIDE_INDEX",
  currentSlideIndex
});

export const setPresentationPresenters = presenters => ({
  type: "SET_PRESENTATION_PRESENTERS",
  presenters
});

export const fetchPresentationUsers = users => ({
  type: "FETCH_PRESENTATION_USERS",
  payload: users
});

export const savePresentation = resp => ({
  type: "SAVE_PRESENTATION",
  payload: resp
});



// WEBPACK FOOTER //
// ./src/actions/actions/presentation.js